import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';


@Component({
  selector: 'app-time-chart',
  templateUrl: './time-chart.component.html',
  styleUrls: ['./time-chart.component.scss']
})
export class TimeChartComponent implements OnInit, AfterViewInit {
  @ViewChild('timeChartCanvas') timeChartCanvas!: ElementRef<HTMLCanvasElement>;
  @Input() data: any;
  customLabel: any = [];
  customData: any = [];
  customShowLabel: any = [];
  private chart: any;
  constructor() { }

  ngOnInit(): void {
    this.dataSet(this.data);
  }

  barMethod(): void {
    Chart.register(ChartDataLabels);
    Chart.defaults.set('plugins.datalabels', {
      color: '#fff'
    });
    const ctx = this.timeChartCanvas?.nativeElement?.getContext('2d');
    if (!ctx) {
      return;
    }

    const filteredDatasets = this.filterOutDataSet(this.customData, this.customLabel);
    const data = {
  labels: this.customLabel,
  datasets: filteredDatasets
};

    this.chart = new Chart(ctx, {
    type: 'bar',
    data,
    options: {
        barValueSpacing: 20,
        scales: {
          xAxes: [{
            barPercentage: 0.4,
            categoryPercentage: 0.4,
            maxBarThickness: 100,
          }],
            yAxes: [{
                ticks: {
                    min: 5,
                },
                barThickness: 20
            }]
        },
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              pointStyle: 'circle',
              padding: 20
              }
          },
        },
    }
});
  }

  ngAfterViewInit(): void {
    this.barMethod();
   }


  dataSet(data: any): void {
    const obj: any = {};
    data.forEach((e: any, index: number) => {
      e?.values?.forEach((el: any) => {
        if (!obj.hasOwnProperty(el.financial_year)) {
          obj[el.financial_year] = {
            key: el?.financial_year,
            label: this.firstLetterCaptial(e.name),
            backgroundColor: this.getBackgroundColor(el.financial_year),
            data: [],
          };
        }
        this.customLabel.push(el.financial_year);
        this.customShowLabel.push(e.name);

        obj[el.financial_year].data.push(el.total_count);
      });
    });
    this.customLabel = this.customLabel.filter((value: any, index: number, self: any) => self.indexOf(value) === index);
    this.customShowLabel = this.customShowLabel.filter((value: any, index: number, self: any) => self.indexOf(value) === index);


    this.customData = {
      labels: this.customLabel,
      datasets: Object.values(obj),
    };
  }

  filterOutDataSet(data: any, labelsToKeep: string[]): any[] {
    return data?.datasets.filter((el: any) => {
      return labelsToKeep.includes(el?.key);
    });
  }

  getBackgroundColor(financialYear: string): string {
    // You can add your logic here to determine the background color based on the financial year
    if (financialYear === '2023-2024') {
      return '#3DB22E';
    } else if (financialYear === '2021-2022') {
      return '#5BE249';
    } else if (financialYear === '2020-2021') {
      return '#FEED76';
    }
    else if (financialYear === '2020-2021') {
      return '#008000';
    }
    else if (financialYear === '2022-2023') {
      return '#e9ffdb';
    }
    return 'gray';
  }
  firstLetterCaptial(value: string): string{
    if (value) {
      const sentence: any = value.split('_');
      return sentence.map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }
    return '';
  }

}
